module.exports = __webpack_public_path__ + "static/media/importexport.c96f76c4.svg";